<template>
  <div>
    <v-row>
      <v-spacer />
      <v-progress-circular
        v-if="loading"
        class="mt-6 mr-2"
        indeterminate
        color="primary"
      />

      <v-col cols="2">
        <v-menu
          v-model="showPickerFrom"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_from"
              label="Od (dátum)"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="date_from"
            no-title
            first-day-of-week="1"
            @input="showPickerFrom = false"
          />
        </v-menu>
      </v-col>
      <v-col cols="2">
        <v-menu
          v-model="showPickerTo"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_to"
              label="Do (dátum)"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="date_to"
            no-title
            first-day-of-week="1"
            @input="showPickerTo = false"
          />
        </v-menu>
      </v-col>
    </v-row>
    <v-subheader>CR+RU podľa ústavov:</v-subheader>
    <div id="chart_celkovo">
      <apexchart
        type="bar"
        height="400"
        :options="chartOptions.celkovo"
        :series="series.celkovo"
      />
    </div>
    <v-subheader>CR podľa ústavov:</v-subheader>
    <div id="chart_cr">
      <apexchart
        type="bar"
        height="400"
        :options="chartOptions.celkovo"
        :series="series.cr"
      />
    </div>
    <v-subheader>RU podľa ústavov:</v-subheader>
    <div id="chart_ru">
      <apexchart
        type="bar"
        height="400"
        :options="chartOptions.celkovo"
        :series="series.ru"
      />
    </div>

    <v-subheader>CR+RU:</v-subheader>
    <div id="chart_ru">
      <apexchart
        type="bar"
        height="400"
        :options="chartOptions.vsetko"
        :series="series.vsetko_celkovo"
      />
    </div>
    <v-subheader>CR:</v-subheader>
    <div id="chart_ru">
      <apexchart
        type="bar"
        height="400"
        :options="chartOptions.vsetko"
        :series="series.vsetko_cr"
      />
    </div>
    <v-subheader>RU:</v-subheader>
    <div id="chart_ru">
      <apexchart
        type="bar"
        height="400"
        :options="chartOptions.vsetko"
        :series="series.vsetko_ru"
      />
    </div>

    <v-subheader>Skóre:</v-subheader>

    <div id="chart_skore">
      <apexchart
        type="area"
        height="400"
        :options="chartOptions.skore"
        :series="series.skore"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VueApexCharts from "vue-apexcharts";
import moment from "moment";

Vue.component("apexchart", VueApexCharts);

const apiService = new APIService();

export default {
  data: () => ({
    loading: false,
    date_from: "2019-10-01",
    date_to: moment().format("YYYY-MM-DD"),

    showPickerFrom: false,
    showPickerTo: false,

    series: {
      celkovo: [],
      cr: [],
      ru: [],
      vsetko_cr: [],
      vsetko_ru: [],
      vsetko_celkovo: [],
      skore: [],
    },
    chartOptions: {
      celkovo: {
        chart: {
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        // responsive: [
        //   {
        //     breakpoint: 480,
        //     options: {
        //       legend: {
        //         position: "bottom",
        //         offsetX: -10,
        //         offsetY: 0,
        //       },
        //     },
        //   },
        // ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },

        xaxis: {
          categories: [],
        },
        legend: {
          position: "right",
          offsetY: 40,
        },
        fill: {
          opacity: 1,
        },
      },
      vsetko: {
        chart: {
          toolbar: {
            show: true,
          },
        },
        // responsive: [
        //   {
        //     breakpoint: 480,
        //     options: {
        //       legend: {
        //         position: "bottom",
        //         offsetX: -10,
        //         offsetY: 0,
        //       },
        //     },
        //   },
        // ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },

        xaxis: {
          categories: [],
        },
        legend: {
          position: "right",
          offsetY: 40,
        },
        fill: {
          opacity: 1,
        },
      },

      skore: {
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },

        xaxis: {
          type: "numeric",
          categories: [],
        },
      },
    },
  }),

  watch: {
    date_from(val) {
      val && this.getStatisticsGraphs();
    },
    date_to(val) {
      val && this.getStatisticsGraphs();
    },
  },

  mounted() {
    this.getStatisticsGraphs();
  },

  methods: {

    getStatisticsGraphs() {
      this.loading = true;
      apiService
        .getStatisticsGraphs(this.date_from, this.date_to)
        .then((response) => {

          this.series.vsetko_cr = [
            {
              name: "Nízke",
              data: [response.vsetko.cr_nizke_vsetko],
            },
            {
              name: "Stredné",
              data: [response.vsetko.cr_stredne_vsetko],
            },

            {
              name: "Vysoké",
              data: [response.vsetko.cr_vysoke_vsetko],
            },
          ];

          this.series.vsetko_ru = [
            {
              name: "Nízke",
              data: [response.vsetko.ru_nizke_vsetko],
            },
            {
              name: "Stredné",
              data: [response.vsetko.ru_stredne_vsetko],
            },

            {
              name: "Vysoké",
              data: [response.vsetko.ru_vysoke_vsetko],
            },
          ];
          this.series.vsetko_celkovo = [
            {
              name: "Nízke",
              data: [response.vsetko.celkovo_nizke_vsetko],
            },
            {
              name: "Stredné",
              data: [response.vsetko.celkovo_stredne_vsetko],
            },

            {
              name: "Vysoké",
              data: [response.vsetko.celkovo_vysoke_vsetko],
            },
          ];

          this.series.celkovo = [
            {
              name: "Nízke",
              data: response.celkovo_nizke,
            },
            {
              name: "Stredné",
              data: response.celkovo_stredne,
            },
            {
              name: "Vysoké",
              data: response.celkovo_vysoke,
            },
          ];

          this.series.cr = [
            {
              name: "Nízke",
              data: response.cr_nizke,
            },
            {
              name: "Stredné",
              data: response.cr_stredne,
            },
            {
              name: "Vysoké",
              data: response.cr_vysoke,
            },
          ];

          this.series.ru = [
            {
              name: "Nízke",
              data: response.ru_nizke,
            },
            {
              name: "Stredné",
              data: response.ru_stredne,
            },
            {
              name: "Vysoké",
              data: response.ru_vysoke,
            },
          ];

          this.series.skore = [
            {
              name: "Celkovo",
              data: response.scores.scores_celkovo,
            },
            {
              name: "CR",
              data: response.scores.scores_cr,
            },
            {
              name: "RU",
              data: response.scores.scores_ru,
            },
          ];

          this.chartOptions.celkovo = {
            chart: {
              stacked: true,
              toolbar: {
                show: true,
              },
              zoom: {
                enabled: true,
              },
            },
            // responsive: [
            //   {
            //     breakpoint: 480,
            //     options: {
            //       legend: {
            //         position: "bottom",
            //         offsetX: -10,
            //         offsetY: 0,
            //       },
            //     },
            //   },
            // ],

            xaxis: {
              type: "category",
              categories: response.categories,
            },

            plotOptions: {
              bar: {
                horizontal: false,
              },
            },

            legend: {
              position: "right",
              offsetY: 40,
            },
            fill: {
              opacity: 1,
            },
          };

          this.chartOptions.vsetko = {
            chart: {
              toolbar: {
                show: true,
              },
            },
            // responsive: [
            //   {
            //     breakpoint: 480,
            //     options: {
            //       legend: {
            //         position: "bottom",
            //         offsetX: -10,
            //         offsetY: 0,
            //       },
            //     },
            //   },
            // ],
            plotOptions: {
              bar: {
                horizontal: false,
              },
            },

            xaxis: {
              type: "category",
              categories: response.vsetko.categories,
            },
            legend: {
              position: "right",
              offsetY: 40,
            },
            fill: {
              opacity: 1,
            },
          };

          this.chartOptions.skore = {
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "smooth",
            },

            xaxis: {
              type: "category",
              categories: response.scores.categories,
            },
          };
          this.loading = false;
        });
    },
  },
};
</script>